import type { NavigationMenu } from '~/types'

export const useNavigation = () => {
  const MENUS: NavigationMenu[] = [
    {
      key: 'layanan',
      title: 'Layanan',
      to: undefined,
      child: [
        {
          group: 'Pengiriman Paket',
          items: [
            {
              title: 'Pengiriman Reguler',
              icon: 'material-symbols:local-shipping-outline',
              description:
                'Layanan pengiriman ke dalam dan luar kota dengan pilihan ekspedisi yang lengkap.',
              to: '/layanan/reguler'
            },
            {
              title: 'Pengiriman Instant',
              icon: 'material-symbols:moped-outline',
              description:
                'Layanan pengiriman dengan estimasi sampai ke penerima dalam hitungan jam.',
              to: '/layanan/instan'
            },
            {
              title: 'Pengiriman Kargo',
              icon: 'material-symbols:directions-boat-outline',
              description:
                'Layanan pengiriman paket berdimensi besar maupun berat dengan ongkir yang lebih hemat.',
              to: '/layanan/kargo'
            }
          ]
        },
        {
          group: 'Marketing',
          items: [
            {
              title: 'ROMS',
              icon: 'ka-icon:roms',
              description:
                'ROMS adalah sistem pintar untuk mengelola repeat order pelangganmu.',
              to: '/layanan/roms'
            }
          ]
        },
        {
          group: 'Keunggulan',
          quickLink: true,
          items: [
            {
              title: 'Kirim COD dan Pencairan Cepat',
              to: '/keunggulan/cod-cair-cepat'
            },
            {
              title: 'Dana COD Cair di Depan',
              to: '/keunggulan/cod-advance'
            },
            {
              title: 'Jaminan Retur Rendah',
              to: '/layanan/rms'
            },
            {
              title: 'Minimalisir Komplain Pembeli',
              to: '/keunggulan/undelivery'
            },
            {
              title: 'Notifikasi Pengiriman ke Pelanggan',
              to: '/keunggulan/whatsapp-followup'
            },
            {
              title: 'Kemudahan Klaim Asuransi dan Retur',
              to: '/keunggulan/klaim-asuransi-dan-retur'
            },
            {
              title: 'Mudah Kirim Ratusan Paket',
              to: '/keunggulan/kirim-paket-massal'
            },
            {
              title: 'Selalu ada Hadiah',
              to: '/solusi/kiriminaja-poin'
            },
            {
              title: 'Pembayaran Praktis',
              to: '/keunggulan/ka-kredit'
            },
            {
              title: 'Pengelolaan Staff yang Mudah',
              to: '/keunggulan/manajemen-staff'
            },
            {
              title: 'Laporan Lengkap',
              to: '/solusi/laporan'
            }
          ]
        }
      ]
    },
    {
      key: 'solusi',
      title: 'Solusi',
      to: undefined,
      child: [
        {
          group: 'Delivery Management System',
          items: [
            {
              title: 'Dashboard',
              icon: 'material-symbols:desktop-mac-outline',
              description:
                'Kelola pengiriman, laporan COD, dan performa bisnis Anda dalam satu tampilan.',
              to: '/solusi/dashboard-member'
            },
            {
              title: 'Aplikasi Mobile',
              icon: 'material-symbols:phone-iphone-outline',
              description:
                'Satu aplikasi untuk kirim barang, cek ongkir, buat resi, lacak kiriman, dan COD lebih cepat.',
              to: '/solusi/aplikasi-mobile'
            },
            {
              title: 'Integrasi API',
              icon: 'material-symbols:settings-ethernet',
              description:
                'Automasi proses logistik end-to-end dengan satu API terintegrasi untuk bisnis Anda.',
              to: '/integration'
            }
          ]
        },
        {
          group: 'Plugin',
          items: [
            {
              title: 'Plugin Shopify',
              icon: 'ic:baseline-shopify',
              description:
                'Hitung ongkir real-time dari berbagai ekspedisi, buat resi otomatis dengan Shopify',
              to: '/solusi/plugin-shopify'
            },
            {
              title: 'Plugin WooCommerce',
              icon: 'ka-icon:woo-commerce',
              description:
                'Tingkatkan penjualan dan efisiensi dengan Plugin WooCommerce KiriminAja. ',
              to: '/solusi/plugin-woocommerce'
            }
          ]
        }
      ]
    },
    {
      key: 'cek-ongkir',
      title: 'Cek Ongkir',
      to: '/cekaja'
    },
    {
      key: 'cek-resi',
      title: 'Cek Resi',
      to: '/tracking'
    },
    {
      key: 'program',
      title: 'Program',
      to: undefined,
      child: [
        {
          items: [
            {
              title: 'Event',
              icon: 'material-symbols:event-note',
              description:
                'Gabung & ikuti keseruan event KiriminAja. Dapatkan insight, peluang dan relasi untuk #NaikKelas',
              to: '/blog/c/event'
            },
            {
              title: 'Promo',
              icon: 'material-symbols:percent',
              description:
                'Jangan lewatkan promo menarik dari KiriminAja! Hemat ongkir, kirim makin untung! Hematnya langsung kerasa!',
              to: '/blog/c/promo'
            }
          ]
        }
      ]
    },
    {
      key: 'panduan',
      title: 'Panduan',
      to: 'https://help.kiriminaja.com',
      target: '_blank',
      rel: 'nofollow',
      external: true,
      footer_only: true
    },
    {
      key: 'pengaduan',
      title: 'Pengaduan',
      to: '/layanan/pengaduan',
      footer_only: true
    },
    {
      key: 'perusahaan',
      title: 'Perusahaan',
      footer_only: true,
      child: [
        {
          items: [
            {
              title: 'Tentang Kami',
              to: '/about'
            },
            {
              title: 'Blog',
              to: '/blog'
            },
            {
              title: 'Press Kit',
              to: '/press-kit'
            }
          ]
        }
      ]
    }
  ]

  const findActiveNav = computed(() => {
    const path = useRoute().path

    for (const nav of MENUS) {
      if (nav.to && path.startsWith(nav.to)) {
        return nav.title
      }

      if (nav.child) {
        for (const child of nav.child) {
          for (const item of child.items) {
            if (item.to && path.startsWith(item.to)) {
              return nav.title
            }
          }
        }
      }
    }

    return undefined
  })

  return {
    MENUS,
    findActiveNav
  }
}
